/* eslint-disable */
import { InvoiceViewDetails, InvoiceHistory, InvoiceListResponse, InvoiceEditDetails } from 'src/interfaces/invoice';
import { getStorageValue } from 'src/hooks/useLocalStorage';
import http from './http';
import axios, { AxiosError } from 'axios';

class InvoiceService {
  static addInvoice(formData: FormData) {
    return http
      .post(`/invoice/create`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
  static updateInvoice(formData: FormData, invoiceId: any) {
    return http
      .patch(`/invoice/update/${invoiceId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static resubmitInvoice(formData: FormData, invoiceId: any) {
    return http
      .patch(`/invoice/resubmit/${invoiceId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static overrideInvoice(formData: FormData, invoiceId: any) {
    return http
      .patch(`/invoice/override/${invoiceId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static approveInvocie(invoiceId: string, invoice: any) {
    return http
      .patch(`/invoice/approve/${invoiceId}`, invoice, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static rejectInvocie(invoiceId: string, invocie: any) {
    return http
      .patch(`/invoice/reject/${invoiceId}`, invocie, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static deleteInvocie(invoiceId: string, invocie: any) {
    return http
      .patch(`/invoice/delete/${invoiceId}`, invocie, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  //   static deleteInvoice(invoiceId: string, invoice: any): Promise<InvoiceViewDetails> {
  //     return http.delete(`/invoice/${invoiceId}`).then(resp => resp.data);
  //   }

  static getInvoiceDetails(params: any): Promise<InvoiceViewDetails> {
    return http.get(`/invoice/detail/${params.invoiceId}`).then(resp => resp.data);
  }

  static getInvoicePdfDownload(params: any): Promise<Blob> {
    return http
      .get(`/invoice/export/pdf/${params.invoiceId}`, {
        responseType: 'blob',
      })
      .then(resp => resp.data);
  }

  static getInvoiceEditDetails(params: any): Promise<InvoiceEditDetails> {
    return http.get(`/invoice/detail/${params.invoiceId}`).then(resp => resp.data);
  }

  static getInvoiceHistory(params: any): Promise<InvoiceHistory[]> {
    return http.get(`/invoice/history/${params.invoiceId}`).then(resp => resp.data);
  }

  static getInvoiceList(params: any): Promise<any> {
    const searchParams = new URLSearchParams();

    // Object.entries(params).forEach(([key, value]) => {
    //   if (value !== undefined && value !== null && value !== '') {
    //     searchParams.append(key, String(value));
    //   }
    // });

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          // Appends each element as a separate query param with the same key
          value.forEach(item => searchParams.append(key, String(item)));
        } else {
          searchParams.append(key, String(value));
        }
      }
    });

    return http.get(`/invoice?${searchParams.toString()}`).then(resp => resp.data);
  }

  static downloadInvoices(params: {
    type?: 'excel' | 'csv' | 'pdf';
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: string;
    hireType?: string;
    showInvocieId?: string;
    assignmentId?: string;
    accountingId?: string;
    // clientName?: string;
    clientName?: string[];
    employeeName?: string;
    dateCriteria?: string;
    dateFilterType?: string;
    startDate?: string;
    endDate?: string;
    companyName?: string;
  }): string {
    const token = getStorageValue('accessToken', null);
    const { type = 'excel', ...rest } = params;

    const queryParams = new URLSearchParams();
    if (token) queryParams.append('token', token);

    // Object.entries(rest).forEach(([key, value]) => {
    //   if (value !== undefined && value !== null && value !== '') {
    //     queryParams.append(key, String(value));
    //   }
    // });

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          // Appends each element as a separate query param with the same key
          value.forEach(item => queryParams.append(key, String(item)));
        } else {
          queryParams.append(key, String(value));
        }
      }
    });

    let endpoint = '';
    switch (type) {
      case 'excel':
        endpoint = 'invoice/export/excel';
        // endpoint = '/invoice/export/excel'; // delete later
        break;
      case 'csv':
        endpoint = 'invoice/export/csv';
        // endpoint = '/invoice/export/csv'; // delete later

        break;
      case 'pdf':
        endpoint = 'invoice/export/pdf-zip';
        // endpoint = '/invoice/export/pdf-zip'; // delete later

        break;
    }

    return `${process.env.REACT_APP_API_URL}${endpoint}?${queryParams.toString()}`;
  }

  static downloadInvoicesBill(params: {
    type?: 'excel' | 'csv' | 'pdf';
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: string;
    hireType?: string;
    showInvocieId?: string;
    assignmentId?: string;
    accountingId?: string;
    // clientName?: string;
    clientName?: string[];
    employeeName?: string;
    dateCriteria?: string;
    dateFilterType?: string;
    startDate?: string;
    endDate?: string;
    companyName?: string;
  }): string {
    const token = getStorageValue('accessToken', null);
    const { type = 'excel', ...rest } = params;

    const queryParams = new URLSearchParams();
    if (token) queryParams.append('token', token);

    // Object.entries(rest).forEach(([key, value]) => {
    //   if (value !== undefined && value !== null && value !== '') {
    //     queryParams.append(key, String(value));
    //   }
    // });

    Object.entries(rest).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          value.forEach(item => queryParams.append(key, String(item)));
        } else {
          queryParams.append(key, String(value));
        }
      }
    });

    let endpoint = '';
    switch (type) {
      case 'excel':
        endpoint = 'invoice/bill-process/export/excel'; // Fixed
        break;
      case 'csv':
        endpoint = 'invoice/bill-process/export/csv';
        // endpoint = '/invoice/export/csv'; // delete later

        break;
      case 'pdf':
        // endpoint = 'invoice/export/pdf-zip';
        endpoint = 'invoice/bill-process/export/pdf-zip'; // delete later

        break;
    }

    return `${process.env.REACT_APP_API_URL}${endpoint}?${queryParams.toString()}`;
  }

  static downloadInvoicesPay(params: {
    type?: 'excel' | 'csv' | 'pdf';
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: string;
    hireType?: string;
    showInvocieId?: string;
    assignmentId?: string;
    accountingId?: string;
    // clientName?: string;
    clientName?: string[];
    employeeName?: string;
    dateCriteria?: string;
    dateFilterType?: string;
    startDate?: string;
    endDate?: string;
    companyName?: string;
  }): string {
    const token = getStorageValue('accessToken', null);
    const { type = 'excel', ...rest } = params;

    const queryParams = new URLSearchParams();
    if (token) queryParams.append('token', token);

    // Object.entries(rest).forEach(([key, value]) => {
    //   if (value !== undefined && value !== null && value !== '') {
    //     queryParams.append(key, String(value));
    //   }
    // });

    Object.entries(rest).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          value.forEach(item => queryParams.append(key, String(item)));
        } else {
          queryParams.append(key, String(value));
        }
      }
    });

    let endpoint = '';
    switch (type) {
      case 'excel':
        // endpoint = 'invoice/export/excel';
        endpoint = 'invoice/pay-process/export/excel'; // delete later
        break;
      case 'csv':
        // endpoint = 'invoice/export/csv';
        endpoint = '/invoice/pay-process/export/csv'; // delete later

        break;
      case 'pdf':
        // endpoint = 'invoice/export/pdf-zip';
        endpoint = 'invoice/pay-process/export/pdf-zip'; // delete later

        break;
    }

    return `${process.env.REACT_APP_API_URL}${endpoint}?${queryParams.toString()}`;
  }

  static getInvoiceBillList(params: any): Promise<{ items: InvoiceListResponse[]; meta: { total: number } }> {
    // let stringParams = '';
    const queryParams = new URLSearchParams();
    // eslint-disable-next-line no-restricted-syntax
    // for (const key in params) {
    //   if (stringParams === '') {
    //     stringParams += `${key}=${params[key]}`;
    //   } else {
    //     stringParams += `&${key}=${params[key]}`;
    //   }
    // }

    for (const key in params) {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          value.forEach(item => queryParams.append(key, String(item)));
        } else {
          queryParams.append(key, String(value));
        }
      }
    }
    return http
      .get(`/invoice/bill-process?${queryParams.toString()}`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data);
  }

  static getInvoicePayList(params: any): Promise<{ items: InvoiceListResponse[]; meta: { total: number } }> {
    let stringParams = '';
    // eslint-disable-next-line no-restricted-syntax
    const queryParams = new URLSearchParams();
    for (const key in params) {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          value.forEach(item => queryParams.append(key, String(item)));
        } else {
          queryParams.append(key, String(value));
        }
      }
    }
    return http
      .get(`/invoice/pay-process?${queryParams.toString()}`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data);
  }

  static processBilling(payload: {
    action: string;
    query: {
      status?: string[];
      companyId?: string;
      employmentType?: string;
      changeType?: string;
      employmentStatus?: string;
      // clientName?: string;
      clientName?: string[];
      hireType?: string;
      workerName?: string;
      dateRangeType?: string;
      startDate?: string | null;
      endDate?: string | null;
    };
  }) {
    return http
      .post('/invoice/bill-process', payload)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  static processPay(payload: {
    action: string;
    query: {
      status?: string[];
    };
  }) {
    return http
      .post('/invoice/pay-process', payload)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  // assignment fetch
  static fetchAssignmentsByEmail(payload: { email: string }) {
    return http
      .post('/assignment/fetch/email', payload)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  static fetchAssignmentsByPersonalNumber(payload: { personnelNumber: string }) {
    return http
      .post('/assignment/fetch/personnelNumber', payload)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  static searchClients(params: { clientSearch: string; limit?: number }) {
    let query = `clientSearch=${params.clientSearch}`;

    if (params.limit) {
      query += `&limit=${params.limit}`;
    }

    return http
      .get(`assignment/clients/search?${query}`)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  static batchDownloadInvoices(params: { batchCode: string }): string {
    return `${http.defaults.baseURL || ''}invoice/batch-download?batchCode=${encodeURIComponent(params.batchCode)}`;
  }
}

export default InvoiceService;
